import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35e2c9fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "content__detail text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "mr-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "flex" }

import { ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmProblemCancelPopup',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
},
  emits: ['confirm', 'close', 'update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const detail = ref('')

const close = () => {
  if (props.modelValue) {
    emit('update:modelValue', !props.modelValue)
    emit('close')
  }
}

const confirm = () => {
  emit('confirm', detail.value)
  close()
}

return (_ctx: any,_cache: any) => {
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    title: _ctx.$t('feedback-help-request.confirm-cancel-class'),
    open: __props.modelValue,
    onClose: close
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-danger text-white text-base w-full",
          onClick: confirm
        }, _toDisplayString(_ctx.$t('feedback-help-request.confirm-cancel')), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('feedback-help-request.if-you-press-confirm')), 1),
          _hoisted_3,
          _createElementVNode("strong", _hoisted_4, _toDisplayString(_ctx.$t('feedback-help-request.this-class-is-canceled')), 1),
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('feedback-help-request.and-can-not-join-room')), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('video-diagnostic.report-comment-header')), 1),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((detail).value = $event)),
            class: "rounded border border-zinc-300 w-full p-3",
            rows: "6",
            placeholder: _ctx.$t('video-diagnostic.report-comment-placeholder')
          }, null, 8, _hoisted_7), [
            [_vModelText, detail.value]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "open"]))
}
}

})